import {getCurrentFabricatorName} from "../../../utilities";
import {PAYMENT_POPUP_SET_JOB_TRANSACTIONS} from "../../../constants/actionTypes";
import {PAYMENT_TYPES, TRANSACTION_STATUSES} from "./jobPaymentReducer";
import {setJobPaymentStatus} from "./jobPaymentActions";

export const postACHPayment = () => {
  return async (dispatch, getState) => {
    const store = getState();
    const {achInfo, jobId, useCustomAmount, percentageAmount, customAmount} = store.jobPaymentState;
    const {accountNumber, routingNumber} = achInfo;
    const ACHPaymentResponse = await getApiConfig('JobBoard/' + jobId + '/payment').post({
      companyName: getCurrentFabricatorName(store),
      accountNumber,
      routingNumber,
      amount: useCustomAmount ? customAmount : percentageAmount,
    });
    console.log("postACHPayment response", ACHPaymentResponse);
    if (ACHPaymentResponse && ACHPaymentResponse.transactionId) {
      dispatch(setJobPaymentStatus({
        status: ACHPaymentResponse.status,
        transactionId: ACHPaymentResponse.transactionId,
      }))
    } else {
      dispatch(setJobPaymentStatus({
        status: TRANSACTION_STATUSES.Error,
        transactionId: "-",
        errorMessage: ACHPaymentResponse ? ACHPaymentResponse.__errorMessage__ : "Payment error"
      }))
    }
    return ACHPaymentResponse
  }
}

export const getJobTransactions = () => {
  return async (dispatch, getState) => {
    const store = getState();
    const {jobId} = store.jobPaymentState;
    const transactionsResponse = await getApiConfig('JobBoard/' + jobId + '/transactions').get();
    console.log("transactions", transactionsResponse);
    dispatch({
      type: PAYMENT_POPUP_SET_JOB_TRANSACTIONS,
      payload: {
        transactionsList: Array.isArray(transactionsResponse) ? transactionsResponse.map(transaction => {
          transaction.paymentType = PAYMENT_TYPES.ACH;
          return transaction;
        }) : [],
      }
    })
    return transactionsResponse
  }
}

